module.exports = __webpack_public_path__ + "img/9788952717153.6d4ee8c7.jpg";